import {
  JobGrade,
  JobRootSpecialtyV2,
  JobSpeciality,
  JobSubSpeciality,
  WorkType,
} from '@/app/types/jobs';
import { SpecialistInfo, specialistInfo } from '@/modules/JobPointOfContact/specialistInfo';

const stringContains = (str: string, substr: string) => {
  return str.toLowerCase().includes(substr.toLowerCase());
};

const getIsGeneralPractice = (specialty: string) =>
  stringContains(specialty, 'General practice') || stringContains(specialty, 'GP -');

export type GetContactForJobProps = {
  specialty?: JobSpeciality | JobRootSpecialtyV2 | JobSubSpeciality;
  countryCode?: string; // AU, NZ etc.
  placementType: WorkType;
  grade?: JobGrade;
};

export const getContactForJob = ({
  specialty,
  countryCode,
  placementType,
  grade,
}: GetContactForJobProps): SpecialistInfo | null => {
  if (!specialty) {
    return null;
  }
  if (!grade || grade !== 'Specialist Consultant') {
    return null;
  }

  if (stringContains(specialty, 'Radiology')) {
    return specialistInfo.jessicaPearson;
  }

  if (stringContains(specialty, 'Family medicine')) {
    return specialistInfo.caraGane;
  }

  const isAustralia = countryCode === 'AU';
  const isPermanentJob = placementType === 'Permanent';
  const isGeneralPractice = getIsGeneralPractice(specialty);

  if (isAustralia && stringContains(specialty, 'General medicine')) {
    return specialistInfo.louiseAnker;
  }

  if (isAustralia && isPermanentJob && !isGeneralPractice) {
    return specialistInfo.elliemaeMiddleton;
  }

  const isNewZealand = countryCode === 'NZ';
  if (isNewZealand && stringContains(specialty, 'Psychiatry')) {
    return specialistInfo.dominiqueRoss;
  }

  return null;
};

export const getRegistrarSpecialistContact = ({
  specialty,
  countryCode,
  placementType,
}: GetContactForJobProps): SpecialistInfo | null => {
  if (!specialty || countryCode !== 'AU' || placementType === 'Permanent') {
    return null;
  }

  if (stringContains(specialty, 'Surgery')) {
    return specialistInfo.sophieSzczudlo;
  }

  if (stringContains(specialty, 'Intensive Care Medicine')) {
    return {
      ...specialistInfo.thropaHearne,
      role: 'Solutions Specialist - ICU Registrar',
    };
  }

  if (stringContains(specialty, 'Anaesthetics')) {
    return specialistInfo.thropaHearne;
  }

  if (stringContains(specialty, 'Psychiatry')) {
    return specialistInfo.katieLovell;
  }

  if (stringContains(specialty, 'Paediatrics')) {
    return specialistInfo.loganMacDonald;
  }

  if (stringContains(specialty, 'Obstetrics and Gynaecology')) {
    return {
      ...specialistInfo.loganMacDonald,
      role: 'Solutions Specialist - O&G Registrar',
    };
  }

  return null;
};
